var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _vm.isHierarchyAllowed
        ? _c(
            "div",
            { staticClass: "col-md-3 mw-230" },
            [
              _c("nested-list-component", {
                attrs: {
                  changeQuery: _vm.changeQuery,
                  type: _vm._.get(_vm.content, "type"),
                  timestamp: _vm.timestamp,
                  endpoint: _vm._.get(_vm.content, "links.new")
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [
          _vm.inlineFormComponent
            ? _c(
                "div",
                [
                  _c(_vm.inlineFormComponent, {
                    tag: "component",
                    attrs: {
                      loading: _vm.loading,
                      type: _vm._.get(_vm.content, "schema.instanceType"),
                      endpoint: _vm._.get(_vm.content, "links.new"),
                      schema: _vm._.get(_vm.content, "schema.attributes"),
                      items: _vm._.get(_vm.content, "data"),
                      parent: _vm.parent,
                      config: _vm.config
                    },
                    on: { input: _vm.addItemForm, "input::batch": _vm.addItems }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm._.get(_vm.config, "toolbarDisabled")
            ? _c(
                "div",
                [
                  _c(
                    "b-navbar",
                    {
                      staticClass: "filter-container",
                      attrs: { toggleable: "md", variant: "" }
                    },
                    [
                      _c(
                        "b-navbar-nav",
                        [
                          _vm._.get(_vm.config, "searchable")
                            ? _c(
                                "b-nav-form",
                                { on: { submit: _vm.changeSearch } },
                                [
                                  _c("b-form-input", {
                                    staticClass: "mr-sm-2",
                                    attrs: {
                                      size: "sm",
                                      type: "text",
                                      placeholder: "Keyword Search"
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-navy btn-search mr-sm-2",
                                      on: { click: _vm.changeSearch }
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("search")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._.get(_vm.config, "searchable") || _vm.hasFilters
                        ? _c("b-navbar-nav", [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-blue-light btn-reset mr-sm-2",
                                attrs: { type: "button" },
                                on: { click: _vm.resetFilters }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("replay")
                                ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasFilters
                        ? _c("b-navbar-nav", [
                            _c(
                              "button",
                              {
                                class: [
                                  _vm.showFilters
                                    ? "btn-show-filter"
                                    : "btn-hide-filter"
                                ],
                                attrs: { type: "button" },
                                on: { click: _vm.toggleFilters }
                              },
                              [
                                _vm._v(
                                  "\n                               " +
                                    _vm._s(
                                      _vm.showFilters
                                        ? "Hide Filters"
                                        : "Show Filters"
                                    )
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasFilters && _vm.showFilters
            ? _c(
                "div",
                [
                  _c(
                    "b-navbar",
                    {
                      staticClass: "filter-container filter-panel",
                      attrs: { toggleable: "md" }
                    },
                    [
                      _c(
                        "b-navbar-nav",
                        { staticClass: "flex-wrap" },
                        [
                          _vm._l(
                            _vm._.get(_vm.config, "customFilters", []),
                            function(filter) {
                              return _c(filter.component, {
                                key: filter.name,
                                tag: "component",
                                attrs: {
                                  changeFilter: _vm.changeFilter,
                                  addFilter: _vm.addFilter,
                                  removeFilter: _vm.removeFilter,
                                  config: filter
                                },
                                model: {
                                  value: filter.value,
                                  callback: function($$v) {
                                    _vm.$set(filter, "value", $$v)
                                  },
                                  expression: "filter.value"
                                }
                              })
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.filterable, function(field) {
                            return _c(
                              "div",
                              { key: field.name },
                              [
                                _c(
                                  "label",
                                  { staticClass: "col-form-label pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getFilteringLabel(field.name))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-nav-item-dropdown",
                                  {
                                    attrs: {
                                      text: _vm.getFilteringText(field.name),
                                      "extra-toggle-classes": "navbar-filter",
                                      "extra-menu-classes": "w-100",
                                      left: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.changeFilter(
                                              field.name,
                                              null
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("-- All --")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(field.values, function(value) {
                                      return _c(
                                        "b-dropdown-item",
                                        {
                                          key: value.id,
                                          on: {
                                            click: function($event) {
                                              return _vm.changeFilter(
                                                field.name,
                                                value.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.__(value.name, ["titleCase"])
                                            )
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pagination && _vm._.get(_vm.config, "pagination")
            ? _c("div", { staticClass: "pagination-wrap" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _vm.pagination.last_page > 1
                        ? _c("b-pagination", {
                            attrs: {
                              align: "left",
                              size: "md",
                              limit: 6,
                              "total-rows": _vm.pagination.total,
                              "per-page": _vm.pagination.perPage
                            },
                            on: { change: _vm.changePage },
                            model: {
                              value: _vm.pagination.currentPage,
                              callback: function($$v) {
                                _vm.$set(_vm.pagination, "currentPage", $$v)
                              },
                              expression: "pagination.currentPage"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col text-center" }, [
                    _c("p", { staticClass: "pagination-count inline-block" }, [
                      _vm._v(
                        "Showing " +
                          _vm._s(_vm.pagination.from) +
                          " to " +
                          _vm._s(_vm.pagination.to) +
                          " of " +
                          _vm._s(_vm.pagination.total) +
                          " " +
                          _vm._s(_vm.__(_vm.content.type, ["titleCase"]))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c("p", { staticClass: "inline-block" }, [
                        _vm._v("Rows per page")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "rows-select",
                        attrs: { options: _vm.pagination.options, cols: "1" },
                        model: {
                          value: _vm.perPage,
                          callback: function($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isEmpty
            ? [
                !_vm._.get(_vm.config, "hideIfEmpty")
                  ? _c(
                      "table",
                      {
                        staticClass: "table b-table table-pages ",
                        staticStyle: { "margin-bottom": "0" }
                      },
                      [
                        _c("thead", [
                          _c(
                            "tr",
                            [
                              _vm.isDraggable
                                ? _c("th", { staticClass: "table-drag" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._.size(_vm._.get(_vm.config, "batchActions"))
                                ? _c("th", { staticClass: "table-check" }, [
                                    _c(
                                      "div",
                                      { staticClass: "checkbox checkbox-only" },
                                      [
                                        _c("input", {
                                          attrs: { type: "checkbox" }
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          attrs: { for: "table-check-head" },
                                          on: { click: _vm.toggleSelectAll }
                                        })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.fields, function(field) {
                                return [
                                  _vm.sortable(field)
                                    ? _c(
                                        "th",
                                        {
                                          key: field,
                                          attrs: {
                                            tabindex: "0",
                                            "aria-colindex": "1"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeSort(field)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getFieldLabel(field) ||
                                                  _vm.__(field, ["titleCase"])
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "th",
                                        {
                                          key: field,
                                          attrs: {
                                            tabindex: "0",
                                            "aria-colindex": "1"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getFieldLabel(field) ||
                                                  _vm.__(field, ["titleCase"])
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                ]
                              }),
                              _vm._v(" "),
                              _c("th", { staticClass: "text-center" }, [
                                _vm._v("Actions")
                              ])
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm._.get(_vm.config, "hideIfEmpty")
                  ? _c(
                      "div",
                      { staticClass: "row", staticStyle: { margin: "0" } },
                      [
                        _c(
                          "div",
                          { staticClass: "col", staticStyle: { padding: "0" } },
                          [
                            _c(
                              "div",
                              { staticClass: "no-content text-center" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/img/sad-face.svg",
                                    alt: "Sad"
                                  }
                                }),
                                _vm._v(" "),
                                _vm._.get(_vm.config, "emptyMessage")
                                  ? _c("h3", [
                                      _vm._v(_vm._s(_vm.config.emptyMessage))
                                    ])
                                  : _c("h3", [
                                      _vm._v(
                                        "You haven't created any " +
                                          _vm._s(
                                            _vm.__(_vm.content.type, [
                                              "lowerCase",
                                              "plural"
                                            ])
                                          ) +
                                          " yet"
                                      )
                                    ]),
                                _vm._v(" "),
                                _vm.creatable
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          "You can create your first " +
                                            _vm._s(
                                              _vm.__(_vm.content.type, [
                                                "singular"
                                              ])
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v("using \u2028the button below")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-lg btn-success btn-rounded",
                                          on: {
                                            click: function($event) {
                                              return _vm.onCreating(
                                                _vm.content.type,
                                                _vm.content.schema
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("add")]
                                          ),
                                          _vm._v(
                                            " Create " +
                                              _vm._s(
                                                _vm.__(_vm.content.type, [
                                                  "titleCase",
                                                  "singular"
                                                ])
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            : _c(
                "div",
                {
                  class: [_vm.isHierarchyAllowed ? "table-responsive-md" : ""]
                },
                [
                  _c(
                    "table",
                    { staticClass: "table b-table table-sorting table-pages" },
                    [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _vm.isDraggable
                              ? _c("th", { staticClass: "table-drag" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._.get(_vm.config, "batchActions.length", 0)
                              ? _c("th", { staticClass: "table-check" }, [
                                  _c(
                                    "div",
                                    { staticClass: "checkbox checkbox-only" },
                                    [
                                      _c("input", {
                                        attrs: { type: "checkbox" }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        attrs: { for: "table-check-head" },
                                        on: { click: _vm.toggleSelectAll }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.fields, function(field) {
                              return [
                                _vm.sortable(field)
                                  ? _c(
                                      "th",
                                      {
                                        key: field,
                                        class: [
                                          "sorting",
                                          _vm.sort[field]
                                            ? "sorting_" + _vm.sort[field]
                                            : ""
                                        ],
                                        attrs: {
                                          tabindex: "0",
                                          "aria-colindex": "1"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changeSort(field)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getFieldLabel(field) ||
                                                _vm.__(field, ["titleCase"])
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        key: field,
                                        attrs: {
                                          tabindex: "0",
                                          "aria-colindex": "1"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getFieldLabel(field) ||
                                                _vm.__(field, ["titleCase"])
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                              ]
                            }),
                            _vm._v(" "),
                            _vm._.get(_vm.config, "actions", []).length > 0
                              ? _c(
                                  "th",
                                  {
                                    staticClass: "text-center table-actions",
                                    staticStyle: { width: "130px" }
                                  },
                                  [_vm._v("Actions")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          attrs: {
                            options: {
                              disabled: !_vm.isDraggable,
                              handle: ".table-drag"
                            },
                            element: "tbody"
                          },
                          on: { end: _vm.changePriority },
                          model: {
                            value: _vm.items,
                            callback: function($$v) {
                              _vm.items = $$v
                            },
                            expression: "items"
                          }
                        },
                        [
                          _vm._l(_vm.items, function(item) {
                            return [
                              _c(
                                "tr",
                                {
                                  key: _vm.content.type + item.id,
                                  class: [_vm.rowClass(item)]
                                },
                                [
                                  _vm.isDraggable
                                    ? _c("td", { staticClass: "table-drag" }, [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("view_headline")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._.get(
                                    _vm.config,
                                    "batchActions.length",
                                    0
                                  )
                                    ? _c("td", { staticClass: "table-check" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "checkbox checkbox-only"
                                          },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked:
                                                  _vm.selected.indexOf(
                                                    item.id
                                                  ) >= 0
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              attrs: { for: "tbl-check-1" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleSelect(
                                                    item.id
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.fields, function(field) {
                                    return _c(
                                      "td",
                                      { key: field },
                                      [
                                        _vm.getFieldComponent(field, item)
                                          ? _c(
                                              _vm.getFieldComponent(
                                                field,
                                                item
                                              ),
                                              {
                                                key: field,
                                                tag: "component",
                                                attrs: {
                                                  initialValue: item[field],
                                                  type: _vm.getFieldType(field),
                                                  schema: _vm.getFieldSchema(
                                                    field
                                                  ),
                                                  data: item,
                                                  config:
                                                    _vm.config.fields[field],
                                                  references: _vm._.get(
                                                    _vm.content,
                                                    "schema.refs"
                                                  )
                                                },
                                                on: {
                                                  change: function(newValue) {
                                                    return _vm.updateItem(
                                                      item.id,
                                                      field,
                                                      newValue,
                                                      item
                                                    )
                                                  }
                                                }
                                              }
                                            )
                                          : [_vm._v(_vm._s(item[field]))]
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm._.get(_vm.config, "actions", []).length >
                                  0
                                    ? _c(
                                        "td",
                                        {
                                          staticClass:
                                            "table-actions text-right"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "btn-group",
                                              attrs: { role: "group" }
                                            },
                                            [
                                              _vm._l(
                                                _vm.config.actions,
                                                function(action) {
                                                  return action.primary
                                                    ? [
                                                        action.component ==
                                                        "view-button"
                                                          ? _c(
                                                              "button",
                                                              {
                                                                key:
                                                                  action.name,
                                                                staticClass:
                                                                  "btn btn-sm btn-secondary-outline",
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeUrl(
                                                                      item.link
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "visibility"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        action.component ==
                                                        "edit-button"
                                                          ? _c(
                                                              "button",
                                                              {
                                                                key:
                                                                  action.name,
                                                                staticClass:
                                                                  "btn btn-sm btn-secondary-outline",
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeUrl(
                                                                      item.link
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "edit"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        action.component ==
                                                        "delete-button"
                                                          ? _c(
                                                              "button",
                                                              {
                                                                key:
                                                                  action.name,
                                                                staticClass:
                                                                  "btn btn-sm btn-secondary-outline",
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteItem(
                                                                      item.id,
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "delete_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        action.component ==
                                                        "preview-button"
                                                          ? _c(
                                                              "button",
                                                              {
                                                                key:
                                                                  action.name,
                                                                staticClass:
                                                                  "btn btn-sm btn-secondary-outline",
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openPreview(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "remove_red_eye"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm._.isObject(
                                                          action.component
                                                        )
                                                          ? _c(
                                                              action.component,
                                                              {
                                                                key:
                                                                  action.name,
                                                                tag:
                                                                  "component",
                                                                attrs: {
                                                                  content: item,
                                                                  config: action,
                                                                  updateBatch:
                                                                    _vm.updateBatch,
                                                                  addNotification:
                                                                    _vm.addNotification
                                                                }
                                                              }
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    : _vm._e()
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._.some(
                                                _vm.config.actions,
                                                function(action) {
                                                  return !action.primary
                                                }
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "table-actions-compact"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-round btn-secondary-outline",
                                                          attrs: {
                                                            type: "button",
                                                            "data-toggle":
                                                              "dropdown"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "material-icons"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "more_horiz"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown-menu dropdown-menu-right text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "ul",
                                                            {
                                                              staticClass:
                                                                "list-unstyled mb-0"
                                                            },
                                                            [
                                                              _vm._l(
                                                                _vm.config
                                                                  .actions,
                                                                function(
                                                                  action
                                                                ) {
                                                                  return !action.primary
                                                                    ? [
                                                                        _c(
                                                                          "li",
                                                                          {
                                                                            key:
                                                                              action.name
                                                                          },
                                                                          [
                                                                            action.component ==
                                                                            "view-button"
                                                                              ? _c(
                                                                                  "a",
                                                                                  {
                                                                                    key:
                                                                                      action.name,
                                                                                    staticClass:
                                                                                      "dropdown-item",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0);"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.changeUrl(
                                                                                          item.link
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "View"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            action.component ==
                                                                            "edit-button"
                                                                              ? _c(
                                                                                  "a",
                                                                                  {
                                                                                    key:
                                                                                      action.name,
                                                                                    staticClass:
                                                                                      "dropdown-item",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0);"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.changeUrl(
                                                                                          item.link
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Edit"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            action.component ==
                                                                            "preview-button"
                                                                              ? _c(
                                                                                  "a",
                                                                                  {
                                                                                    key:
                                                                                      action.name,
                                                                                    staticClass:
                                                                                      "dropdown-item",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0);"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.openPreview(
                                                                                          item
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Preview"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            action.component ==
                                                                            "delete-button"
                                                                              ? _c(
                                                                                  "a",
                                                                                  {
                                                                                    key:
                                                                                      action.name,
                                                                                    staticClass:
                                                                                      "dropdown-item",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0);"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.deleteItem(
                                                                                          item.id,
                                                                                          item
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Delete"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            action.component ==
                                                                            "link-button"
                                                                              ? _c(
                                                                                  "a",
                                                                                  {
                                                                                    key:
                                                                                      action.name,
                                                                                    staticClass:
                                                                                      "dropdown-item",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0);"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.changeUrl(
                                                                                          item.link +
                                                                                            "/" +
                                                                                            action.path
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        action.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm._.isObject(
                                                                              action.component
                                                                            )
                                                                              ? _c(
                                                                                  action.component,
                                                                                  {
                                                                                    key:
                                                                                      action.name,
                                                                                    tag:
                                                                                      "component",
                                                                                    attrs: {
                                                                                      content: item,
                                                                                      config: action,
                                                                                      updateBatch:
                                                                                        _vm.updateBatch,
                                                                                      addNotification:
                                                                                        _vm.addNotification
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    : _vm._e()
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              ),
          _vm._v(" "),
          _vm.pagination && _vm._.get(_vm.config, "pagination")
            ? _c("div", { staticClass: "pagination-wrap" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _vm.pagination.last_page > 1
                        ? _c("b-pagination", {
                            attrs: {
                              align: "left",
                              size: "md",
                              limit: 6,
                              "total-rows": _vm.pagination.total,
                              "per-page": _vm.pagination.perPage
                            },
                            on: { change: _vm.changePage },
                            model: {
                              value: _vm.pagination.currentPage,
                              callback: function($$v) {
                                _vm.$set(_vm.pagination, "currentPage", $$v)
                              },
                              expression: "pagination.currentPage"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col text-center" }, [
                    _c("p", { staticClass: "pagination-count inline-block" }, [
                      _vm._v(
                        "Showing " +
                          _vm._s(_vm.pagination.from) +
                          " to " +
                          _vm._s(_vm.pagination.to) +
                          " of " +
                          _vm._s(_vm.pagination.total) +
                          " " +
                          _vm._s(_vm.__(_vm.content.type, ["titleCase"]))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c("p", { staticClass: "inline-block" }, [
                        _vm._v("Rows per page")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "rows-select",
                        attrs: { options: _vm.pagination.options, cols: "1" },
                        model: {
                          value: _vm.perPage,
                          callback: function($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3d209d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3d209d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/TableComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e3d209d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/TableComponent.vue
// module chunks = 0